import {
  ADD_CARD,
  UPDATE_CARD,
  DELETE_CARD,
  // TODO: import action types added later
} from './types'

function addCard(card) {
  return {
    type: ADD_CARD,
    payload: {
      card,
    },
  }
}

function updateCard(card) {
  return {
    type: UPDATE_CARD,
    payload: {
      card,
    },
  }
}

function deleteCard(card) {
  return {
    type: DELETE_CARD,
    payload: {
      card,
    },
  }
}

export { addCard, updateCard, deleteCard }
